import React from 'react';
import { Button, Stack, SxProps, Theme } from '@mui/material';

import palette from '@/theme/palette.ts';

type TextButtonWithIconProps = {
  iconName: string;
  label: string;
  onClick: () => void;
  sx?: SxProps<Theme>;
};

export const TextButtonWithIcon = ({ iconName, label, onClick, sx }: TextButtonWithIconProps) => {
  return (
    <Button
      variant="text"
      size="large"
      sx={{ color: palette.primary.main, ...sx }}
      onClick={onClick}
    >
      <Stack direction="row" gap={1} alignItems="center">
        <span className="material-symbols-rounded" style={{ color: palette.primary.main }}>
          {iconName}
        </span>
        {label}
      </Stack>
    </Button>
  );
};
